import Home from "../components/pages/Home";
import About from "../components/pages/About";

import Contact from "../components/pages/Contact";
import FAQ from "../components/pages/FAQ";
import Profile from "../components/pages/Profile";
import MyTasks from "../components/pages/MyTasks";
// import MyProjects from '../components/pages/user-projects';
import TaskDetails from "../components/pages/TaskDetails";

import Projects from "../components/pages/Projects";
import ProjectDetails from "../components/pages/ProjectDetails";

import Messages from "../components/pages/Messages";
import Earnings from "../components/pages/Earnings";
import Payments from "../components/pages/Payments";
import SavedJobs from "../components/pages/SavedJobs";
import Reviews from "../components/pages/Reviews";

// Jobs
import { Jobs } from "../components/pages/Jobs/index";


// import ResetPassword from '../components/pages/ResetPassword';
import Register from "../components/pages/Register";
import ForgotPassword from "../components/pages/ForgotPassword";
import Login from "../components/pages/Login";

//Locations
import Countries from '../components/pages/admin/admin-locations/Countries';
import Regions from '../components/pages/admin/admin-locations/Regions';
import UsersPage from '../components/pages/admin/admin-locations/UsersPage';
import ProjectsPage from "../components/pages/admin/admin-locations/ProjectsPage";
import CitiesPage from "../components/pages/admin/admin-locations/CitiesPage";

import NotFound from "../components/pages/NotFound";
import RegionsInCountryPage from "../components/pages/admin/admin-locations/RegionsInCountryPage";

export const User_Home = {
  path: "/",
  name: "Home",
  component: Home,
};

export const User_About = {
  path: "/about",
  name: "About",
  component: About,
};

export const User_Contact = {
  path: "/contact",
  name: "Contact",
  component: Contact,
};

export const User_FAQ = {
  path: "/faq",
  name: "FAQ",
  component: FAQ,
};

export const User_Profile = {
  path: "/profile",
  name: "Profile",
  component: Profile,
};

export const User_Messages = {
  path: "/dashboard/messages",
  name: "Messages",
  component: Messages,
};

// export const User_Settings = {
//   path: '/dashboard/settings',
//   name: 'Settings',
//   component: () => import('../components/pages/Settings'),
// };

export const User_MyTasks = {
  path: "/mytasks",
  name: "MyTasks",
  component: MyTasks,
};

// export const User_MyProjects = {
//   path: '/myprojects',
//   name: 'MyProjects',
//   component: MyProjects,
// };

export const User_ProjectDetails = {
  path: "/project-details/:id",
  name: "ProjectDetails",
  component: ProjectDetails,
};

export const User_TaskDetails = {
  path: "/task-details",
  name: "TaskDetails",
  component: TaskDetails,
};

export const User_Projects = {
  path: "/projects",
  name: "Projects",
  component: Projects,
};

export const User_Login = {
  path: "/login",
  name: "Login",
  component: Login,
};

export const User_Register = {
  path: "/register",
  name: "Register",
  component: Register,
};

export const User_ForgotPassword = {
  path: "/forgot-password",
  name: "ForgotPassword",
  component: ForgotPassword,
};

export const User_Earnings = {
  path: "/dashboard/earnings",
  name: "Earnings",
  component: Earnings,
};

export const User_Payments = {
  path: "/dashboard/payments",
  name: "Payments",
  component: Payments,
};

export const User_dashboard = {
  path: "/dashboard",
  name: "UserDashboard",
  component: () => import("../components/layout/Dashboard/Home"),
};

export const User_SavedJobs = {
  path: "/dashboard/saved-jobs",
  name: "SavedJobs",
  component: SavedJobs,
};

export const User_Reviews = {
  path: "/dashboard/reviews",
  name: "Reviews",
  component: Reviews,
};

export const Path_NotFound = {
  path: "/404",
  name: "NotFound",
  component: NotFound,
};

export const User_Jobs = {
  path: "/dashboard/jobs",
  name: "Jobs",
  component: Jobs,
};

export const Admin_Countries = {
  path: '/admin/location/countries',
  name: 'Countries',
  component: Countries,
};

export const Admin_Regions = {
  path: '/admin/location/regions',
  name: 'Regions',
  component: Regions,
};

export const Admin_Users = {
  path: '/admin/location/users',
  name: 'Users',
  component: UsersPage,
};

export const Admin_Projects = {
  path: '/admin/location/projects',
  name: 'ProjectsPage',
  component: ProjectsPage,
};

export const Admin_Cities = {
  path: '/admin/location/cities',
  name: 'CitiesPage',
  component: CitiesPage,
};

export const Admin_Regions_In_Country = {
  path: '/admin/location/regions_in_a_country',
  name: 'RegionsInCountryPage',
  component: RegionsInCountryPage,
};
